import {useUnit} from 'effector-react';
import {useEffect} from 'react';
import {$callsStore, fetchCallDetailRequested, updateCallBookmark, updateCallInterest, createIdeaRequested, createIdeaFx, fetchCallCommentsRequested, createCommentRequested, createCommentFx, fetchCallGoalsRequested} from '../store';
import {CallResponse} from '../model/types';

export const useCallDetailViewModel = (callId: string | undefined) => {
  const [callsState, fetchCallDetail, updateBookmark, updateInterest, createIdea, createIdeaLoading, fetchComments, createComment, createCommentLoading, fetchCallGoals] = useUnit([
    $callsStore,
    fetchCallDetailRequested,
    updateCallBookmark,
    updateCallInterest,
    createIdeaRequested,
    createIdeaFx.pending,
    fetchCallCommentsRequested,
    createCommentRequested,
    createCommentFx.pending,
    fetchCallGoalsRequested,
  ]);

  const fetchCallById = (id: string) => {
    fetchCallDetail(id);
  };

  useEffect(() => {
    if (callId) {
      fetchCallDetail(callId);
      fetchComments(callId);
      fetchCallGoals(callId);
    }
  }, [callId, fetchCallDetail, fetchComments, fetchCallGoals]);

  const getCallDetail = (): CallResponse | null => {
    return callsState.selectedCall;
  };

  return {
    call: callsState.selectedCall,
    loading: callsState.loading,
    error: callsState.error,
    fetchCallById,
    getCallDetail,
    updateBookmark,
    updateInterest,
    createIdea,
    createIdeaLoading,
    comments: callsState.comments,
    commentsLoading: callsState.commentsLoading,
    commentsError: callsState.commentsError,
    fetchComments,
    createComment,
    createCommentLoading,
    createCommentError: callsState.createCommentError,
    // Call goals data
    callGoals: callsState.callGoals,
    callGoalsLoading: callsState.callGoalsLoading,
    callGoalsError: callsState.callGoalsError,
  };
};
